import { StockReportTable } from "./StockReportTable";

export default StockReportTable;
